<template>
    <div class="body">
        <div class="back" @click="$router.go(-1)">
            <img src="../../assets/img/i19.png" />
            返回
        </div>
        <div class="content">
            <div class="c_top">
                <div class="ct_left">
                    <img :src="webImg + info.icon" />
                    <div>{{ info.name }}</div>
                    <img class="jl" src="../../assets/img/i4.png" @click="$router.push({
                        path: '/historyChat', query: {
                            id: assistantId
                        }
                    })" />
                </div>
                <div class="ct_right">
                    助手说明：<span>{{ info.note }}</span>
                </div>
            </div>

            <div class="c_bottom">
                <div class="cb_item" v-for="(item, index) in templateList" :key="index" v-if="item.attrName">
                    <div class="cbi_top"><span>*</span>{{ item.attrName }}</div>
                    <div class="cbi_bottom1">
                        <el-select v-model="item.selectName" placeholder="请选择" @change="oneChange($event, index)">
                            <el-option v-for="(itemA, indexA) in item.attrValues" :key="indexA"
                                :value="itemA"></el-option>
                        </el-select>
                    </div>
                </div>
                <div class="cb_item" v-for="(item, index) in templateList" :key="index" v-if="!item.attrName">
                    <div class="cbi_top"><span v-if="item.requiredFlag == 1">*</span>{{ item.title }}</div>
                    <div class="cbi_bottom" v-if="item.type != 2">
                        <input maxlength="5000" :placeholder="item.defaultVal ? item.defaultVal : '请输入'"
                            v-model="item.text" v-if="item.type == 0" />
                        <textarea maxlength="5000" :placeholder="item.defaultVal ? item.defaultVal : '请输入'"
                            v-model="item.text" v-if="item.type == 1"></textarea>
                    </div>
                    <div class="cbi_bottom1" v-if="item.type == 2">
                        <el-select v-model="item.text" placeholder="请选择" @change="twoChange($event, index)">
                            <el-option v-for="(itemA, indexA) in item.opt" :key="indexA" :value="itemA"></el-option>
                        </el-select>
                    </div>
                </div>
                <div class="cb_item" v-if="(info && info.name) && !info.name.includes('文生图')">
                    <div class="cbi_top">参考资料</div>
                    <div class="cbi_bottom" style="display: flex;align-items: center;">
                        <el-upload :headers="myHeaders" :http-request="handleUploadForm" :on-change="imgSaveToUrl"
                            :show-file-list="false" action class="upload-demo" multiple
                            accept=".doc,.docx,.pdf,.xls,.xlsx,.ppt,.pptx">
                            <el-button type="primary">上传文件</el-button>
                        </el-upload>
                        <el-upload style="margin-left: 20px;" :headers="myHeaders" :http-request="handleUploadImgForm" :on-change="imgSaveToUrl"
                            :show-file-list="false" action class="upload-demo" multiple accept="image/*">
                            <el-button type="primary">上传图片</el-button>
                        </el-upload>
                    </div>
                </div>
                <div class="file">
                    <div class="f_item" v-for="(item, index) in fileList" :key="index">
                        <img class="fi_icon" :src="settingFileIcon(item.resourceType, item.path)" />
                        <div class="fi_text line1_">{{ item.name || item.path }}</div>
                        <img class="fi_del" src="../../assets/img/i52.png" @click="btn_delFile(item, index)" />
                    </div>
                </div>
            </div>
        </div>
        <div class="btn" @click="next">智能生成</div>
    </div>
</template>

<script>
import axios from 'axios'
import { createSession, helperInfo, nextPromptOption, promptInfo,ossToken } from '@/apis/index'
export default {
    data() {
        return {
            assistantItem: {},
            assistantId: '',
            sessionId: '', //会话ID
            info: {},
            templateList: [], //提示词模板列表用于渲染
            prompts: '', //提示词
            fileList: [], //用于页面展示的文件资源等
            imgList: [],
            scrollTop: 0, // 页面滚动的距离
            navBarOpacity: 0, // 导航栏的不透明度
            navBarAlternateThreshold: 5, // 另一个导航栏开始显示的滚动阈值
            popShow: false,
            myHeaders: { "X-Token": ossToken() },
        }
    },
    mounted() {
        if (this.$route.query.item) {
            console.log(JSON.parse(decodeURIComponent(this.$route.query.item)), 'item');
            var obj = JSON.parse(decodeURIComponent(this.$route.query.item))
            console.log(obj, 'obj');
            // this.assistantItem = obj
            this.assistantId = obj.id
            this.getHelperInfo()
            this.getCreateSession()
        }
    },
    methods: {
        btn_delFile(item, index) {
            this.fileList.splice(index, 1);
            this.$forceUpdate();
        },
        handleUploadImgForm(param) {
            console.log(param, 'imgup');
            const formData = new FormData();
            formData.append("multipart", param.file);
            let loading = this.$loading({
                lock: true,
                text: "上传中，请稍候...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            // 获取上传token
            ossToken(param.file.name).then(res => {
                let ossRes = JSON.parse(res.data);
                console.log(ossRes, 'getOssToken')
                const ossData = new FormData();
                Object.keys(ossRes).forEach((key) => {
                    ossData.append(key, ossRes[key]);
                });
                console.log(param.file, 'param.file')
                ossData.append("file", param.file);
                var url = ossRes.host;
                axios({
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    method: 'post',
                    url: url,
                    data: ossData
                }).then(async (res2) => {
                    console.log(res2, 'getOssToken axios')
                    this.fileList.push({
                        path: res2.data.url,
                        resourceType: 2,
                        select: 1,
                        name: param.file.name
                    })
                    console.log(this.icon, 'icon');
                    loading.close();
                })
            })
        },
        // 上传
        handleUploadForm(param) {
            const formData = new FormData();
            formData.append("multipart", param.file);
            let loading = this.$loading({
                lock: true,
                text: "上传中，请稍候...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            // 获取上传token
            ossToken(param.file.name).then(res => {
                let ossRes = JSON.parse(res.data);
                console.log(ossRes, 'getOssToken')
                const ossData = new FormData();
                Object.keys(ossRes).forEach((key) => {
                    ossData.append(key, ossRes[key]);
                });
                ossData.append("file", param.file);
                var url = ossRes.host;
                axios({
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    method: 'post',
                    url: url,
                    data: ossData
                }).then(async (res2) => {
                    console.log(res2, 'getOssToken axios')
                    this.fileList.push({
                        path: res2.data.url,
                        resourceType: 3,
                        select: 1,
                        name: param.file.name
                    })
                    loading.close();
                })
            })
        },
        // 选取图片后自动回调，里面可以获取到文件
        imgSaveToUrl(event) {
            console.log(event, 'eventOnchange');
        },
        twoChange(e, index) {
            console.log(e, 'e', index);
            this.templateList[index].text = e
            this.$forceUpdate()
        },
        oneChange(e, index) {
            console.log(e, 'e', index);
            this.templateList[index].selectName = e
            var list = []
            this.templateList.forEach(itemA => {
                if (itemA.selectName) {
                    const newObj = {
                        [itemA.attrName]: itemA.selectName
                    };
                    list.push(newObj)
                }
            })

            const result = list.reduce((accumulator, current) => {
                return {
                    ...accumulator,
                    ...current
                };
            }, {});

            if (this.templateList[index + 1] && this.templateList[index + 1].attrName) {
                nextPromptOption({
                    helperId: this.assistantId,
                    attrValue: JSON.stringify(result)
                }).then(res => {
                    console.log(res, 'nextPromptOption');
                    this.templateList[index + 1].attrValues = res.data
                })
            }

            var templateList = this.templateList.filter(item => item.attrName)
            if (templateList.length !== list.length) {
                return
            }

            promptInfo({
                helperId: this.assistantId,
                attrValue: JSON.stringify(result)
            }).then(res => {
                this.prompts = res.data.prompt
                this.templateList = this.templateList.filter((itemA) => {
                    console.log(itemA, 'itemA');
                    return itemA.attrName;
                });
                res.data.promptList.forEach(itemB => {
                    itemB.text = ''
                })
                this.templateList = [...this.templateList, ...res.data.promptList]
                this.$forceUpdate()
            })
        },
        arrayToRichText(array) {
            let html = '<div>';
            for (let i = 0; i < array.length; i++) {
                if (array[i].text) {
                    html += `<div>${array[i].title + ':  ' + array[i].text}</div>`;
                } else if (array[i].attrName) {
                    html += `<div>${array[i].attrName + ':  ' + array[i].selectName}</div>`;
                }
            }
            html += '</div>';
            return html;
        },
        next() {
            this.templateList.forEach(e => {
                if (!e.text && e.defaultVal) {
                    e.text = e.defaultVal
                }
            })
            var fList = this.templateList.filter(item => {
                return (!item.text && item.requiredFlag == 1) || item.selectName == ''
            })
            if (fList.length > 0) {
                return this.$message.warning('请先将必填项完成')
            }
            this.uFileList = [...this.fileList, ...this.imgList]
            var obj = {
                sessionId: this.sessionId,
                prompts: this.prompts,
                templateList: this.templateList,
                fileList: this.uFileList,
                assistantItem: this.assistantItem,
                info: this.info
            }
            // localStorage.setItem('callWord', obj)
            localStorage.setItem('callWord', JSON.stringify(obj))
            this.$router.push({ path: '/chat' })
        },
        getCreateSession() {
            createSession(this.assistantId).then(res => {
                console.log(res, 'createSession');
                this.sessionId = res.data
            })
        },
        getHelperInfo() {
            helperInfo(this.assistantId).then(res => {
                console.log(res, 'helperInfo');
                this.assistantItem = res.data
                this.info = res.data
                if (this.info.extraAttrFlag == 0) {
                    this.info.promptList.forEach(itemB => {
                        itemB.text = ''
                        if (itemB.opt) {
                            itemB.opt = itemB.opt.split(',')
                        }
                    })
                    this.templateList = this.info.promptList
                    this.prompts = this.info.prompt
                } else {
                    this.info.attrList.forEach(itemB => {
                        itemB.text = ''
                    })
                    this.templateList = this.info.attrList
                    this.templateList.forEach(e => {
                        if (e.attrValues) {
                            e.selectName = ''
                            e.attrValues = e.attrValues.split(',')
                        }
                    })
                    this.prompts = this.info.prompt
                }
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.body {
    width: 900px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .back {
        width: 100%;
        display: flex;
        align-items: center;
        font-weight: bold;
        font-size: 14px;
        color: #000000;
        // margin-bottom: 10px;
        margin-top: 10px;
        cursor: pointer;
        box-sizing: border-box;

        img {
            width: 14px;
            height: 14px;

        }
    }

    .btn {
        width: 200px;
        height: 52px;
        background: #2992FF;
        border-radius: 8px;
        font-weight: bold;
        font-size: 20px;
        color: #FFFFFF;
        text-align: center;
        line-height: 52px;
        margin-bottom: 20px;
        cursor: pointer;
        background: linear-gradient(90deg, #7671fa, #62b7fb, #5cc2de);
        user-select: none;
        transform: scale(1);

        &:hover {
            box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
        }

        &:active {
            transform: scale(0.97) !important;
        }
    }

    // .content::-webkit-scrollbar {
    //     display: none;
    // }

    .content {
        width: 100%;
        flex: 1;
        height: 0;
        // overflow-y: scroll;
        margin: 20px 0;
        display: flex;
        align-items: center;

        .c_top {
            width: 45%;
            height: 100%;
            display: flex;
            flex-direction: column;
            // justify-content: flex-start;
            // align-items: center;
            // justify-content: center;
            box-sizing: border-box;
            // padding: 0 40px;
            padding-top: 40px;

            .ct_left {
                display: flex;
                align-items: center;
                text-align: center;
                font-weight: 400;
                font-size: 24px;
                color: #212121;

                img {
                    width: 50px;
                    height: 50px;
                }

                div {
                    flex: 1;
                    text-align: left;
                    margin: 0 10px;
                }

                .jl {
                    width: 25px;
                    height: 25px;
                    margin-right: 30px;
                    cursor: pointer;
                }
            }

            .ct_right {
                flex: 1;
                font-weight: bold;
                font-size: 16px;
                color: #333333;
                margin-top: 20px;

                span {
                    font-weight: 500;
                    font-size: 16px;
                    color: #333333;
                    margin-top: 20px;
                    line-height: 30px;
                    letter-spacing: 1px;
                }
            }
        }

        .c_bottom::-webkit-scrollbar {
            display: none;
        }

        .c_bottom {
            flex: 1;
            height: 100%;
            width: 65%;
            overflow-y: scroll;
            box-sizing: border-box;
            margin-left: 20px;
            // padding-top: 40px;
            // display: flex;
            // align-items: flex-start;
            // justify-content: space-between;
            // flex-wrap: wrap;
            .file {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .f_item:nth-child(3n) {
        margin-right: 0 !important;
    }

    .f_item {
        width: 100%;
        height: 55px;
        border-radius: 8px;
        box-sizing: border-box;
        padding: 8px;
        display: flex;
        align-items: center;
        background-color: rgba(0, 0, 0, 0.03);
        margin-right: 15px;
        margin-top: 15px;

        .fi_icon {
            width: 30px;
            height: 30px;
        }

        .fi_text {
            color: #000000;
            font-size: 14px;
            font-weight: 500;
            flex: 1;
            margin: 0 10px;
        }

        .fi_del {
            width: 20px;
            height: 20px;
            cursor: pointer;
        }
    }
}
            .cb_item {
                width: 440px;
                margin-top: 40px;

                .cbi_top {
                    width: 100%;
                    font-weight: bold;
                    font-size: 16px;
                    color: #252525;

                    span {
                        font-weight: 500;
                        font-size: 16px;
                        color: #FF0000;
                        margin-right: 5px;
                    }
                }

                .cbi_bottom1 {
                    width: 100%;
                    margin-top: 10px;

                    .el-select {
                        width: 100%;
                    }
                }

                .cbi_bottom {
                    width: 100%;
                    margin-top: 10px;

                    input {
                        width: 100%;
                        height: 40px;
                        background: #FFFFFF;
                        border-radius: 2px 2px 2px 2px;
                        border: 1px solid #E2E6ED;
                        box-sizing: border-box;
                        padding: 0 10px;
                        font-weight: 500;
                        font-size: 14px;
                    }

                    textarea {
                        width: 100%;
                        height: 100px;
                        background: #FFFFFF;
                        border-radius: 2px 2px 2px 2px;
                        border: 1px solid #E2E6ED;
                        box-sizing: border-box;
                        padding: 10px;
                        font-weight: 500;
                        font-size: 14px;
                    }
                }
            }
        }
    }
}
</style>